/**
 * The connection dialog's title row (Option C, C1): the title and a close glyph. The entry points that used to sit
 * here (C0) moved to the start view, the rail and the compact bar's "Add from…". 56 px tall; 40 px in the short tier
 * (plan §3.5 budget). The close glyph always closes, like Cancel (Escape steps back first in a create-mode form).
 */
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';

type Props = { isEditMode: boolean; short: boolean; onClose: () => void };

export function ConnectionDialogHeader({ isEditMode, short, onClose }: Props) {
  return (
    <DialogHeader
      data-dialog-fixed
      className={cn('shrink-0 flex-row items-center justify-between space-y-0 border-b pl-6 pr-3.5 text-left', short ? 'h-10' : 'h-14')}
    >
      <DialogTitle className={cn('leading-5', short ? 'text-base' : 'text-lg')}>{isEditMode ? 'Edit connection' : 'New connection'}</DialogTitle>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="grid h-7 w-7 place-items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        data-testid="connection-dialog-close-button"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </DialogHeader>
  );
}
